<template>
  <i class="icon_wrap"
    :class="{disabled}"></i>
</template>

<script>
export default {
  name: 'delay',
  props: {
    disabled: Boolean
  }
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 24px
  height 24px
  background-size 24px 24px
  background-repeat no-repeat
  background-position center
  background-image url('./images/h5_payment_icon_sel_@3x.png')
  &.disabled {
    background-image url('./images/h5_payment_icon_sel_disabled@3x.png')
  }
}
</style>
